import React, { useState, useEffect, useContext, createContext } from 'react';


import { DataContext } from '../../../init/getData';
import { PosCartContext } from '../../../init/posCartData';

import { Modal, Col, Form, Row, DropdownButton, Dropdown, InputGroup, Card } from 'react-bootstrap';
import { Button } from 'antd';

import AsyncSelect from 'react-select/async';
import AsyncCreatableSelect from 'react-select/creatable';

import toast from 'react-hot-toast';
import KeyPad from '../../../components/keyPad/keyPad';
import { FaUserPlus } from "react-icons/fa6";

import Loader from '../../../components/loader/loader';
import DeliveryForm from '../../../accountTab/delivery/deliveryForm';




function DeliveryModal(props) {

  const { showModal, toggleModal, title, selectedTab, } = props;

  const { settingData, deliveryData, refData, companyId, loadDeliveryOptions, deliveryOptions } = useContext(DataContext);
  const { tabData, setTabData, setJournalVoucher } = useContext(PosCartContext);

  const [loadingEffect, setLoadingEffect] = useState(false);
  const [inputValue, setInputValue] = useState("");
  const [showAddModal, setShowAddModal] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [addedDeliveryId, setAddedDeliveryId] = useState("");


  const openModal = () => {
    setShowAddModal(!showAddModal);
  }


  const cart = tabData[selectedTab].cart;
  const journalVoucher = tabData[selectedTab].journalVoucher;





  const fetchData = async () => {
    try {
      setIsLoading(true);
      const dataArray = ['delivery']
      await refData(dataArray, companyId);
      setIsLoading(false);
    } catch (error) {
      console.error('Error refreshing data Contact Support');
    }
  };


  useEffect(() => {
    setInputValue("");
  }, [showModal]);

  useEffect(() => {
    if (addedDeliveryId) {
      fetchData();
      let updatedJv = { ...journalVoucher };
      updatedJv.deliveryId = addedDeliveryId;

      setJournalVoucher(updatedJv, selectedTab)
    }
  }, [addedDeliveryId]);



  // handle select change
  const handleSelectChange = (selectedOption, name) => {
    let updatedJv = { ...journalVoucher };
    updatedJv.deliveryId = selectedOption?.value || null;

    setJournalVoucher(updatedJv, selectedTab)
  };

  const closeModal = () => {
    toggleModal();
  }

  return (
    <Modal show={showModal} onHide={toggleModal} backdrop='static'>
      <Modal.Header style={{ background: "#1d7790" }}>
        <Modal.Title style={{ color: "white" }}>{title}</Modal.Title>
      </Modal.Header>
      <Modal.Body>

        {isLoading &&
          <Loader />
        }

        {!isLoading &&
          <Row className="mb-4" style={{ marginTop: '4vh' }}>
            <Col>
              <AsyncSelect
                cacheOptions
                isClearable={true}
                loadOptions={loadDeliveryOptions}
                defaultOptions={[]}
                onChange={(e) => handleSelectChange(e, 'deliveryId')}
                value={deliveryOptions?.find(option => option.value === journalVoucher.deliveryId)}
                noOptionsMessage={() => 'type to view'}
                autoFocus
                onKeyDown={(e) => { if (e.key === 'Enter') { closeModal() } }}
              />
            </Col>


            <Col md={2}>
              <FaUserPlus size={30} style={{ cursor: 'pointer' }} onClick={openModal} />
            </Col>

          </Row>
        }



      </Modal.Body>
      <Modal.Footer>
        <div>
          <Button type="primary" size="large" loading={loadingEffect} onClick={closeModal}
            style={{ marginLeft: '10px', backgroundColor: '#1d7790' }} danger>Done</Button>
        </div>
      </Modal.Footer>

      {openModal &&
        <DeliveryForm
          showModal={showAddModal}
          toggleModal={openModal}
          idRow={null}
          setAddedDeliveryId={setAddedDeliveryId}
        />
      }


    </Modal>

  );
}

export default DeliveryModal;
